__turbopack_context__.v({
  "active": "MenuDrawer-module-scss-module__AER7ZG__active",
  "activeDot": "MenuDrawer-module-scss-module__AER7ZG__activeDot",
  "chevron": "MenuDrawer-module-scss-module__AER7ZG__chevron",
  "container": "MenuDrawer-module-scss-module__AER7ZG__container",
  "drawerContent": "MenuDrawer-module-scss-module__AER7ZG__drawerContent",
  "drawerFooter": "MenuDrawer-module-scss-module__AER7ZG__drawerFooter",
  "expandButton": "MenuDrawer-module-scss-module__AER7ZG__expandButton",
  "expandableRow": "MenuDrawer-module-scss-module__AER7ZG__expandableRow",
  "expandableRowActive": "MenuDrawer-module-scss-module__AER7ZG__expandableRowActive",
  "listRoot": "MenuDrawer-module-scss-module__AER7ZG__listRoot",
  "nav": "MenuDrawer-module-scss-module__AER7ZG__nav",
  "navLink": "MenuDrawer-module-scss-module__AER7ZG__navLink",
  "navList": "MenuDrawer-module-scss-module__AER7ZG__navList",
  "sublink": "MenuDrawer-module-scss-module__AER7ZG__sublink",
  "sublinksList": "MenuDrawer-module-scss-module__AER7ZG__sublinksList",
});
